import { convertCurrency } from '@yy/one-currency'
import { PaginationType, WalletListType } from '@/store/walletSlice/types'
import * as Types from './type'
import Api from '@/services/http'

/**
 * 获取预占流水列表
 * @param params
 * @returns
 */
export const fetchPreemptList = async (params: Types.OrderDetailPageReq) => {
  const res = await Api.admin.post('/api/wallet/admin/order-detail/page-freeze', params)
  return res.data
}

/**
 * 获取钱包流水列表
 * @param params
 * @returns
 */
export const fetchWalletList = async (params: WalletListType & PaginationType) => {
  const res = await Api.admin.post<Types.FlowListRes>('/api/wallet/admin/order-detail/page', params)
  return res.data
}

/**
 * 查询充值套餐信息
 * @returns
 */
export const postRechargeInfo = (param: Types.RechargeInfoParams) => Api.admin.post<Types.RechargeInfoRes>('/api/crm/admin/package/pay/recharge_info', param)

/** 查询套餐优惠 */
export const getPromotionCoupon = (params: Types.GetPromotionCouponParams) =>
  Api.admin.post<Types.GetPromotionCouponResp>('/api/crm/admin/package/pay/get-promotion-coupon', { ...params })

/**
 * 创建支付
 * @description
 * 入参为**元**
 */
export const postCreateWalletPay = (params: Types.PostCreateWalletPayParams) => {
  const finalParams = convertCurrency(params).centify(['customPackageAmount'])
  return Api.admin.post<Types.PayCreateRes>('/api/crm/admin/subscription/pay/create', finalParams)
}

/**
 * 各个国家支持的支付方式
 * @returns
 */
export const postPayMethodList = () => Api.admin.post('/api/dictionary_query/list?group=ONESHIP_ONLINE_PAY_TYPE')

/**
 * 导出钱包流水
 * @param params
 * @returns
 */
export const postWalletFlowExport = (params: WalletListType) => Api.admin.post('/api/wallet/flow/export', params)

/**
 * 保存钱包余额监控设置
 * @param params
 * @returns
 */
export const walletMonitorSettingSave = (params: Types.BalanceThresholdParams) => Api.normal.post('/api/wallet/admin/setting/monitor-save', params)

/**
 * 查询钱包余额监控设置
 * @param params
 * @returns
 */
export const walletMonitorSettingGet = () => Api.normal.post<{ walletMonitorSettingBos: Types.BalanceThresholdParams[] }>('/api/wallet/admin/setting/monitor-list')

/** 获取支付方式和对应的支付平台 */
export const getPayChannelList = (params: { countryCode: string; currencyCode: string }) => Api.admin.post<Types.PayChannelListRes>('/api/crm/admin/pay/pay-channel-list', params)
/** 获取账单信息 */
export const getSettlement = (params: { packageSeqList: string[]; currencyCode: string }) => Api.admin.post('/api/crm/admin/package/pay/settlement', params)

/** 创建订单 */
export const createPayBill = (params: Types.CreatePayBillParams) => Api.admin.post('/api/crm/admin/pay/create', params)

/** 查询内部支付状态 */
export const postPayStatus = (params: Types.GetPayStatusReq) => Api.admin.post<Types.GetPayStatusRes>('/api/crm/admin/subscription/pay/get-pay-status', params)

/**
 * 查询套餐优惠
 * @description
 * 入参出参都为**元**
 */
export const fetchPackageFee = async (params: Types.FetchPackageFeeParams) => {
  const finalParams = convertCurrency(params).centify(['customPackageAmount'])
  const resp = await Api.admin.post<Types.FetchPackageFeeResp>('/api/crm/admin/package/pay/calculatePackageFee', finalParams)
  return convertCurrency(resp?.data).yuanify(['totalPayAmount', 'taxAmount', 'amount', 'couponAmount', 'amountNext', 'couponAmountNext'])
}
